export const GET_ALL_PORTALS = "GET_ALL_PORTALS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_PORTALS = "START_LOADING_PORTALS";
export const STOP_LOADING_PORTALS = "STOP_LOADING_PORTALS";
export const ERROR_LOADING_PORTALS = "ERROR_LOADING_PORTALS";